import { Dialog, Sheet } from "@gravity-ui/uikit";
import { ExportJobDto } from "definitions/exporter";

import { ExportLogsContent } from "../ExportLogsContent";

interface ExportLogsSheetProps {
  open: boolean;
  job: ExportJobDto | null;
  metadata: string;
  onClose: () => void;
}

export const ExportLogsSheet = ({
  open,
  job,
  metadata,
  onClose,
}: ExportLogsSheetProps) => {
  return (
    <Sheet visible={open} onClose={onClose}>
      <Dialog.Body>
        <ExportLogsContent job={job} onClose={onClose} metadata={metadata} />
      </Dialog.Body>
    </Sheet>
  );
};
